<template>
    <div class="group-head">
        <div class="group-name" :class="{ en: $i18n.locale === 'en' }" :style="{
            'max-width': config && config.width || undefined
        }" v-html="group.name">{{group.name}}</div>
        <div v-if="$i18n.locale !== 'en'" class="group-name-en" :style="{
            'max-width': config && config.enWidth || undefined
        }" v-html="group.nameEN">{{group.nameEN}}</div>
        <slot />
    </div>
</template>

<script>
export default {
    props: ['group', 'config']
};
</script>


<style lang="less" scoped>
    .group-head {
        margin-bottom: 64px;
        padding-top: 16px;
        // position: relative;
        .group-name {
            color: #1A1A1A;
            font-size: 32px;
            line-height: 32px;
            display: inline-block;
            position: relative;
            font-weight: bold;
            &.en {
                font-size: 30px;
            }
            &:after {
                content: '';
                display: block;
                width: 122px;
                height: 96px;
                background-image: url(//res-fengche.souche.com/f2e/1d28d17ef7c0428ac1e372296da2f7e8.png);
                background-size: 100%;
                background-position: center;
                background-repeat: no-repeat;
                position: absolute;
                top: -24px;
                right: -42px;
                z-index: -1;
            }
        }
        .group-name-en {
            margin-top: 14px;
            color: #FF571A;
            font-size: 14px;
            line-height: 18px;
            letter-spacing: 1px;
            text-transform: uppercase;
            width: 320px;
        }
    }
    @media screen and (max-width: 540px) {
        .group-head {
            padding-top: 20px/2;
            margin-bottom: 32px/2;
            .group-name {
                font-size: 40px/2;
                line-height: 40px/2;
                &.en {
                    font-size: 20px;
                }
                &:after {
                    width: 165px/2;
                    height: 131px/2;
                    top: -25px/2;
                    right: -61px/2;
                }
            }
            .group-name-en {
                margin-top: 20px/2;
                font-size: 20px/2;
                line-height: 28px/2;
                letter-spacing: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/GroupHead.vue